var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBovineFatBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3021",
    "data-name": "Group 3021",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.21,
    height: 15.551,
    viewBox: "0 0 21.21 15.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3386",
    "data-name": "Path 3386",
    d: "M24.34,658.9a.391.391,0,1,1-.391.391A.392.392,0,0,1,24.34,658.9Z",
    transform: "translate(-17.937 -652.917)",
    fill: "#22294D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3387",
    "data-name": "Path 3387",
    d: "M6.634,645.943a.367.367,0,0,1-.366-.351c-.054-1.252-1.3-1.373-3.058-1.408a10.044,10.044,0,0,1-1.281-.076A3.545,3.545,0,0,1-.6,642.685a.367.367,0,0,1-.024-.329,3.626,3.626,0,0,1,2.769-2.1,3.622,3.622,0,0,1,2.271.275,2.339,2.339,0,0,0,1.31.188.367.367,0,0,1,.1.726,3.062,3.062,0,0,1-1.714-.247,2.894,2.894,0,0,0-1.813-.226,2.955,2.955,0,0,0-2.16,1.474,2.317,2.317,0,0,0,.335.307,3.432,3.432,0,0,0,1.563.627,9.613,9.613,0,0,0,1.182.067,8.1,8.1,0,0,1,2.36.276,2.177,2.177,0,0,1,.977.628A1.942,1.942,0,0,1,7,645.561a.367.367,0,0,1-.35.382Z",
    transform: "translate(0.647 -638.778)",
    fill: "#22294D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3388",
    "data-name": "Path 3388",
    d: "M11.556,646.076a.871.871,0,0,1-.524-.175,3.615,3.615,0,0,0-1.9-.761,2.341,2.341,0,0,0-.765.05.367.367,0,1,1-.214-.7,3.888,3.888,0,0,1,3.32.827.135.135,0,0,0,.107.025.133.133,0,0,0,.09-.061,3.955,3.955,0,0,1,.28-.405.367.367,0,1,1,.568.463,3.283,3.283,0,0,0-.225.328.868.868,0,0,1-.738.411Z",
    transform: "translate(-5.807 -641.96)",
    fill: "#22294D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3389",
    "data-name": "Path 3389",
    d: "M25.782,667.26c-.194,0-.386,0-.572-.013a3.1,3.1,0,0,1-2.869-2.365l-.433-1.788a6.558,6.558,0,0,1-1.044-1.789,8.6,8.6,0,0,1-.544-3.676.367.367,0,1,1,.729.078,7.623,7.623,0,0,0,.074,1.728,6.544,6.544,0,0,0,1.4,3.252.367.367,0,0,1,.077.152l.453,1.872a2.38,2.38,0,0,0,2.191,1.805c.174.008.355.013.537.013a.367.367,0,1,1,0,.733Z",
    transform: "translate(-15.177 -651.709)",
    fill: "#22294D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3390",
    "data-name": "Path 3390",
    d: "M33.368,660.269A.367.367,0,0,1,33,659.9v-2.429a2.972,2.972,0,0,0-.232-1.2,1.656,1.656,0,0,0-.233-.4l0,0,.539-.5a3.171,3.171,0,0,1,.656,2.086V659.9A.367.367,0,0,1,33.368,660.269Z",
    transform: "translate(-24.425 -650.264)",
    fill: "#22294D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1016",
    "data-name": "Line 1016",
    d: "M-1.133.18A.367.367,0,0,1-1.5-.187v-.947A.367.367,0,0,1-1.133-1.5a.367.367,0,0,1,.367.367v.947A.367.367,0,0,1-1.133.18Z",
    transform: "translate(11.738 14.277)",
    fill: "#22294D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3392",
    "data-name": "Path 3392",
    d: "M55.2,645.943h-.016a.367.367,0,0,1-.35-.382,1.942,1.942,0,0,1,.439-1.206,2.177,2.177,0,0,1,.977-.628,8.1,8.1,0,0,1,2.359-.276,9.586,9.586,0,0,0,1.182-.067,3.432,3.432,0,0,0,1.563-.626,2.318,2.318,0,0,0,.335-.307,2.955,2.955,0,0,0-2.16-1.474,2.9,2.9,0,0,0-1.814.226,3.1,3.1,0,0,1-1.848.243.367.367,0,0,1,.131-.722,2.372,2.372,0,0,0,1.414-.189,3.855,3.855,0,0,1,5.041,1.822.367.367,0,0,1-.024.329,3.545,3.545,0,0,1-2.524,1.423,10.063,10.063,0,0,1-1.281.076c-1.756.035-3,.156-3.057,1.408A.367.367,0,0,1,55.2,645.943Z",
    transform: "translate(-41.273 -638.778)",
    fill: "#22294D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3393",
    "data-name": "Path 3393",
    d: "M58.714,658.9a.391.391,0,1,1-.392.391A.392.392,0,0,1,58.714,658.9Z",
    transform: "translate(-43.908 -652.917)",
    fill: "#22294D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3394",
    "data-name": "Path 3394",
    d: "M59.368,646.076a.859.859,0,0,1-.16-.015.869.869,0,0,1-.578-.4,3.337,3.337,0,0,0-.225-.328.367.367,0,1,1,.568-.463,3.992,3.992,0,0,1,.28.405.133.133,0,0,0,.09.061.135.135,0,0,0,.107-.025,3.889,3.889,0,0,1,3.32-.827l-.214.7h0a2.4,2.4,0,0,0-.8-.048,3.611,3.611,0,0,0-1.863.758A.871.871,0,0,1,59.368,646.076Z",
    transform: "translate(-43.908 -641.96)",
    fill: "#22294D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3395",
    "data-name": "Path 3395",
    d: "M41.6,667.26a.367.367,0,1,1,0-.733c.182,0,.363,0,.537-.013a2.38,2.38,0,0,0,2.191-1.805l.453-1.872a.367.367,0,0,1,.077-.152,7.318,7.318,0,0,0,1.474-4.98.367.367,0,1,1,.729-.078,8.6,8.6,0,0,1-.544,3.676,6.559,6.559,0,0,1-1.044,1.789l-.433,1.788a3.1,3.1,0,0,1-2.869,2.365C41.989,667.255,41.8,667.26,41.6,667.26Z",
    transform: "translate(-30.999 -651.709)",
    fill: "#22294D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3396",
    "data-name": "Path 3396",
    d: "M48.4,660.269a.367.367,0,0,1-.367-.367v-2.429a3.171,3.171,0,0,1,.656-2.086l.539.5,0,0a1.656,1.656,0,0,0-.233.4,2.972,2.972,0,0,0-.232,1.2V659.9A.367.367,0,0,1,48.4,660.269Z",
    transform: "translate(-36.136 -650.264)",
    fill: "#22294D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3397",
    "data-name": "Path 3397",
    d: "M37.133,680.862a.367.367,0,0,1-.366-.343,1.352,1.352,0,0,0-.441-.338l-.019-.01a3.412,3.412,0,0,1-.719-.564.928.928,0,0,1-.192-1.023.947.947,0,0,1,.874-.58H38a.947.947,0,0,1,.874.58.928.928,0,0,1-.192,1.023,3.413,3.413,0,0,1-.719.564l-.02.011a1.351,1.351,0,0,0-.44.337A.367.367,0,0,1,37.133,680.862Zm-.463-1.328a2.788,2.788,0,0,1,.364.23q.053.04.1.08.047-.04.1-.08a2.788,2.788,0,0,1,.364-.23,2.679,2.679,0,0,0,.556-.438.2.2,0,0,0,.042-.226.209.209,0,0,0-.2-.132H36.27a.209.209,0,0,0-.2.132.2.2,0,0,0,.042.226A2.681,2.681,0,0,0,36.67,679.533Z",
    transform: "translate(-26.529 -667.351)",
    fill: "#22294D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1017",
    "data-name": "Line 1017",
    d: "M-1.133.18A.367.367,0,0,1-1.5-.187v-.947A.367.367,0,0,1-1.133-1.5a.367.367,0,0,1,.367.367v.947A.367.367,0,0,1-1.133.18Z",
    transform: "translate(11.738 14.277)",
    fill: "#22294D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3398",
    "data-name": "Path 3398",
    d: "M41.6,689.917a.367.367,0,1,1,0-.733,1.829,1.829,0,0,0,.869-.181.786.786,0,0,0,.176-.123.367.367,0,1,1,.584.443A1.986,1.986,0,0,1,41.6,689.917Z",
    transform: "translate(-30.999 -675.459)",
    fill: "#22294D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3399",
    "data-name": "Path 3399",
    d: "M24.525,638.921a.367.367,0,0,1-.364-.326,1.585,1.585,0,1,1,3.161-.174.367.367,0,0,1-.733,0,.852.852,0,1,0-1.7.093.367.367,0,0,1-.324.4Z",
    transform: "translate(-18.089 -636.247)",
    fill: "#22294D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3400",
    "data-name": "Path 3400",
    d: "M31.248,635.828a.367.367,0,0,1-.326-.533,1.586,1.586,0,0,1,2.806-.036.367.367,0,0,1-.644.35.852.852,0,0,0-1.509.019A.367.367,0,0,1,31.248,635.828Z",
    transform: "translate(-23.175 -634.429)",
    fill: "#22294D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3401",
    "data-name": "Path 3401",
    d: "M39.589,636.294h-.026a.367.367,0,0,1-.34-.391,1.586,1.586,0,0,1,3.111-.3.367.367,0,0,1-.708.192.852.852,0,0,0-1.672.163A.367.367,0,0,1,39.589,636.294Z",
    transform: "translate(-29.477 -634.428)",
    fill: "#22294D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3402",
    "data-name": "Path 3402",
    d: "M50.8,638.347a.367.367,0,0,1-.354-.463.852.852,0,1,0-1.674-.223.367.367,0,0,1-.733,0,1.585,1.585,0,1,1,3.115.415A.367.367,0,0,1,50.8,638.347Z",
    transform: "translate(-36.136 -635.673)",
    fill: "#22294D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3403",
    "data-name": "Path 3403",
    d: "M40.2,643.274a1.139,1.139,0,0,1-.445-.093,1.164,1.164,0,0,1-.444-.328.855.855,0,0,1-.207-.544.367.367,0,1,1,.733,0,.32.32,0,0,0,.2.2.315.315,0,0,0,.352-.042.367.367,0,0,1,.509.528A1,1,0,0,1,40.2,643.274Z",
    transform: "translate(-29.385 -640.106)",
    fill: "#22294D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3404",
    "data-name": "Path 3404",
    d: "M49.027,645.491a1.042,1.042,0,0,1-.25-.031.954.954,0,0,1-.736-.71.367.367,0,0,1,.722-.127.288.288,0,0,0,.2.127c.113.024.162-.015.182-.04a.367.367,0,0,1,.581.448A.869.869,0,0,1,49.027,645.491Z",
    transform: "translate(-36.136 -641.903)",
    fill: "#22294D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBovineFatBlue);
export default __webpack_public_path__ + "static/media/bovine_fat_blue.d70fc87d3e8e7208abaeccea0181d5ee.svg";
export { ForwardRef as ReactComponent };